export default {
  'app.settings.menuMap.basic': '基本設定',
  'app.settings.menuMap.security': 'セキュリティ設定',
  'app.settings.menuMap.binding': 'アカウントのバインド',
  'app.settings.menuMap.notification': '新しいメッセージの通知',
  'app.settings.basic.avatar': 'アバター',
  'app.settings.basic.change-avatar': 'アバターを変更する',
  'app.settings.basic.email': 'メール',
  'app.settings.basic.email-message': 'メールアドレスを入力してください！',
  'app.settings.basic.nickname': 'ニックネーム',
  'app.settings.basic.nickname-message': 'ニックネームを入力してください！',
  'app.settings.basic.profile': '個人プロフィール',
  'app.settings.basic.profile-message': '個人プロフィールを入力してください!',
  'app.settings.basic.profile-placeholder': '自己紹介',
  'app.settings.basic.country': '国/地域',
  'app.settings.basic.country-message': 'あなたの国を入力してください!',
  'app.settings.basic.geographic': '州または市',
  'app.settings.basic.geographic-message': '地理情報を入力してください!',
  'app.settings.basic.address': '住所',
  'app.settings.basic.address-message': '住所を入力してください!',
  'app.settings.basic.phone': '電話番号',
  'app.settings.basic.phone-message': '電話番号を入力してください!',
  'app.settings.basic.update': '更新情報',
  'app.settings.security.strong': '強い',
  'app.settings.security.medium': 'ミディアム',
  'app.settings.security.weak': '弱い',
  'app.settings.security.password': 'アカウントパスワード',
  'app.settings.security.password-description': '現在のパスワードの強度',
  'app.settings.security.phone': 'セキュリティ電話番号',
  'app.settings.security.phone-description': 'バインドされた電話番号',
  'app.settings.security.question': '秘密の質問',
  'app.settings.security.question-description':
    'セキュリティの質問が設定されてません。セキュリティポリシーはアカウントのセキュリティを効果的に保護できます',
  'app.settings.security.email': 'バックアップメール',
  'app.settings.security.email-description': 'バインドされたメール',
  'app.settings.security.mfa': '多要素認証デバイス',
  'app.settings.security.mfa-description':
    'バインドされていない多要素認証デバイスは、バインド後、2回確認できます',
  'app.settings.security.modify': '変更する',
  'app.settings.security.set': 'セットする',
  'app.settings.security.bind': 'バインド',
  'app.settings.binding.taobao': 'タオバオをバインドする',
  'app.settings.binding.taobao-description':
    '現在バインドされていないタオバオアカウント',
  'app.settings.binding.alipay': 'アリペイをバインドする',
  'app.settings.binding.alipay-description':
    '現在バインドされていないアリペイアカウント',
  'app.settings.binding.dingding': 'ディントークをバインドする',
  'app.settings.binding.dingding-description':
    '現在バインドされていないディントークアカウント',
  'app.settings.binding.bind': 'バインド',
  'app.settings.notification.password': 'アカウントパスワード',
  'app.settings.notification.password-description':
    '他のユーザーからのメッセージは、ステーションレターの形式で通知されます',
  'app.settings.notification.messages': 'システムメッセージ',
  'app.settings.notification.messages-description':
    'システムメッセージは、ステーションレターの形式で通知されます',
  'app.settings.notification.todo': 'To Do（用事) 通知',
  'app.settings.notification.todo-description':
    'To Doタスクは、内部レターの形式で通知されます',
  'app.settings.open': '開く',
  'app.settings.close': '閉じる',
  'kg.settings.pageSubtitle':
    'プラットフォーム知識グラフの既定動作、表示戦略、抽出ルール、ガバナンス閾値を統一管理します。',
  'kg.settings.navLabel': '設定グループ',
  'kg.settings.pageEyebrow': 'プラットフォーム知識グラフ設定',
  'kg.settings.noticeTitle': '変更はプラットフォーム級の設定に直接反映されます',
  'kg.settings.noticeDescription':
    'できるだけグループごとに保存してください。未保存の変更がある状態で切り替えると、編集継続か破棄かを確認します。',
  'kg.settings.lastUpdated': '最終更新',
  'kg.settings.sections.basic.title': '基本設定',
  'kg.settings.sections.basic.description':
    '既定ビュー、既定タイプ、既定検索範囲を設定します。',
  'kg.settings.sections.basic.intro':
    '管理者が最初にグラフ作業画面へ入るときの既定コンテキストを定義します。',
  'kg.settings.sections.display.title': '表示戦略',
  'kg.settings.sections.display.description':
    'レイアウト、密度、サマリー表示を統一的に制御します。',
  'kg.settings.sections.display.intro':
    '表示戦略により、同じグラフでも管理者ごとの差が出ない安定した閲覧体験を保ちます。',
  'kg.settings.sections.extraction.title': '抽出と審査',
  'kg.settings.sections.extraction.description':
    'AI 抽出モデル、閾値、レビュー条件を管理します。',
  'kg.settings.sections.extraction.intro':
    'インポート後に自動抽出するか、どの結果を自動承認するかをここで決めます。',
  'kg.settings.sections.governance.title': 'ガバナンス既定値',
  'kg.settings.sections.governance.description':
    '重複排除、インポート、システム型保護の既定ルールを定義します。',
  'kg.settings.sections.governance.intro':
    '一括インポート、エンティティ重複排除、組み込み型の編集境界に影響するため、プラットフォーム管理者が統一管理してください。',
  'kg.settings.actions.restoreDefaults': 'プラットフォーム既定値に戻す',
  'kg.settings.actions.cancel': 'キャンセル',
  'kg.settings.actions.discard': '変更を破棄',
  'kg.settings.actions.continueEditing': '編集を続ける',
  'kg.settings.actions.resetSection': '現在のグループをリセット',
  'kg.settings.actions.saveSection': '現在のグループを保存',
  'kg.settings.messages.loadFailed':
    '設定の読み込みに失敗しました。後でもう一度お試しください。',
  'kg.settings.messages.leaveTitle': 'このグループに未保存の変更があります',
  'kg.settings.messages.leaveContent':
    '切り替える前に、編集を続けるか、未保存の変更を破棄するかを選択してください。',
  'kg.settings.messages.saveFailed':
    '設定の保存に失敗しました。後でもう一度お試しください。',
  'kg.settings.messages.resetTitle': 'プラットフォーム既定値に戻しますか？',
  'kg.settings.messages.resetContent':
    '既定値へ戻すと、すべてのグループの保存済み設定が上書きされます。現在の運用に影響がないことを確認してください。',
  'kg.settings.messages.resetSuccess':
    'プラットフォーム知識グラフ設定を既定値に戻しました',
  'kg.settings.messages.resetFailed':
    '既定値への復元に失敗しました。後でもう一度お試しください。',
  'kg.settings.messages.basicSaved': '基本設定を保存しました',
  'kg.settings.messages.displaySaved': '表示戦略を保存しました',
  'kg.settings.messages.extractionSaved': '抽出と審査設定を保存しました',
  'kg.settings.messages.governanceSaved': 'ガバナンス既定値を保存しました',
  'kg.settings.fields.defaultViewName': '既定グラフビュー名',
  'kg.settings.fields.defaultSearchScope': '既定検索範囲',
  'kg.settings.fields.defaultEntityType': '既定エンティティタイプ',
  'kg.settings.fields.defaultRelationType': '既定関係タイプ',
  'kg.settings.fields.autoExpandRelatedEntities': '関連エンティティを自動展開',
  'kg.settings.fields.defaultLayout': '既定レイアウト',
  'kg.settings.fields.nodeDensity': 'ノード密度',
  'kg.settings.fields.showRelationLabels': '関係ラベルを表示',
  'kg.settings.fields.enableNodeAggregation': 'ノード集約を有効化',
  'kg.settings.fields.showPropertySummary': '属性サマリーパネルを表示',
  'kg.settings.fields.highlightPathOnHover': 'ホバー時にパスを強調',
  'kg.settings.fields.modelProvider': '既定抽出モデル',
  'kg.settings.fields.promptStrategy': 'プロンプト戦略',
  'kg.settings.fields.confidenceThreshold': '信頼度閾値',
  'kg.settings.fields.autoApproveThreshold': '自動承認閾値',
  'kg.settings.fields.autoExtractOnImport': 'インポート後に自動抽出',
  'kg.settings.fields.requireManualReview': '自動承認未満は手動審査',
  'kg.settings.fields.enableRiskBlocking': '高リスク遮断を有効化',
  'kg.settings.fields.deduplicationMode': '既定重複排除戦略',
  'kg.settings.fields.defaultSourceStatus': '新規データ既定状態',
  'kg.settings.fields.maxImportBatchSize': '一括インポート上限',
  'kg.settings.fields.enableChangeAudit': '変更監査を有効化',
  'kg.settings.fields.lockSystemTypes': '組み込み型をロック',
  'kg.settings.placeholders.defaultViewName':
    '例: プラットフォーム知識グラフ全体',
  'kg.settings.placeholders.defaultEntityType': '既定エンティティタイプを選択',
  'kg.settings.placeholders.defaultRelationType': '既定関係タイプを選択',
  'kg.settings.validation.defaultViewName':
    '既定グラフビュー名を入力してください',
  'kg.settings.options.scope.platform': 'プラットフォーム',
  'kg.settings.options.scope.tenant': 'テナント',
  'kg.settings.options.layout.force': '力学',
  'kg.settings.options.layout.radial': '放射',
  'kg.settings.options.layout.dagre': '階層',
  'kg.settings.options.density.comfortable': 'ゆったり',
  'kg.settings.options.density.balanced': '標準',
  'kg.settings.options.density.compact': '高密度',
  'kg.settings.options.prompt.balanced': '標準',
  'kg.settings.options.prompt.strict': '厳格',
  'kg.settings.options.prompt.aggressive': '積極',
  'kg.settings.options.deduplication.manual': '手動確認',
  'kg.settings.options.deduplication.semiAuto': '半自動統合',
  'kg.settings.options.deduplication.strict': '厳格重複排除',
  'kg.settings.options.sourceStatus.draft': '下書き',
  'kg.settings.options.sourceStatus.active': '有効',
  'kg.settings.blocks.basic.title': '既定の開始動作',
  'kg.settings.blocks.basic.description':
    'グラフ作業画面に入るときの既定展開と検索コンテキストを定義します。',
  'kg.settings.blocks.display.title': 'キャンバス表示項目',
  'kg.settings.blocks.display.description':
    'ノード、関係、属性サマリーの既定表示を制御します。',
  'kg.settings.blocks.extraction.title': '抽出実行ポリシー',
  'kg.settings.blocks.extraction.description':
    'インポート後の認識、自動承認、リスク遮断条件を制御します。',
  'kg.settings.blocks.governance.title': 'ガバナンス実行ポリシー',
  'kg.settings.blocks.governance.description':
    '重複排除、インポート、組み込み機能保護の既定境界を管理します。',
  'kg.settings.help.autoExpandRelatedEntities':
    '有効にすると、エンティティ詳細や既定ビューで一次関連ノードを自動展開します。',
  'kg.settings.help.showRelationLabels':
    '無効時は、関係ラベルはフォーカスまたは選択時のみ表示されます。',
  'kg.settings.help.enableNodeAggregation':
    '大規模グラフの初期表示ノイズを減らすため、類似ノードを集約します。',
  'kg.settings.help.showPropertySummary':
    'ノード側面パネルで主要属性の要約を既定表示します。',
  'kg.settings.help.highlightPathOnHover':
    'ノードや関係にホバーした際、上下流パスを強調表示します。',
  'kg.settings.help.autoExtractOnImport':
    'インポート完了後、AI 抽出フローを即時に開始します。',
  'kg.settings.help.requireManualReview':
    '自動承認閾値に達しない結果は手動審査キューへ送られます。',
  'kg.settings.help.enableRiskBlocking':
    '高リスクな関係や敏感項目変更に追加遮断を適用します。',
  'kg.settings.help.enableChangeAudit':
    '重要設定の変更者、変更時刻、変更内容を記録します。',
  'kg.settings.help.lockSystemTypes':
    '組み込みエンティティタイプと関係タイプの安易な変更を防ぎます。',
};
